//#region react/redux
import React, { Component } from "react"
import { Link } from "react-router-dom"
import Menu from "react-dd-menu"
//#endregion react/redux

import { PATH } from "../../modules/constants"
import { COLOR } from "../../modules/colors_&_filters"

import {
  Button,
  Tooltip,
  Typography
} from '@mui/material'

import history from '../../services/history'

export class UserMenu extends Component {
  state = {
    isMenuOpen: false
  }

  toggle() {
    this.setState({ isMenuOpen: !this.state.isMenuOpen })
  }

  close() {
    if (this.refs.myRef && this.state.isMenuOpen) {
      this.setState({ isMenuOpen: false })
    }
  }

  logout() {
    this.setState({ isMenuOpen: false }, () => this.props.logout())
  }

  switchUser() {
    // console.log("switchUser")
    this.props.logout()
    history.push(`/${PATH.LOGIN}`)
  }

  disconnect() {
    this.setState({ isMenuOpen: false }, () => this.props.disconnect())
  }

  historyPush = pathname => this.props.common.selectRow({ ...this.props, pathname })

  renderButton() {
    // console.log('renderButton this.props:', this.props)
    const { name, isLoggedIn, page } = this.props
    return (
      <React.Fragment>
        <div style={{ display: "flex" }}>
          {!isLoggedIn && page !== "Register" &&
            <Tooltip title="click to register">
              <Button
                size="small"
                variant="login"
                aria-label="register"
                onClick={() => { history.push(`/${PATH.REGISTER}?origin=appregisterbutton`) }}
                sx={{ minWidth: 160, whiteSpace: "nowrap", backgroundColor: COLOR.GOOD }}
              >
                Register for Free Trial
              </Button>
            </Tooltip>
          }

          {!isLoggedIn && page !== "Login" &&
            <Tooltip title="click to login">
              <Button
                size="small"
                variant="login"
                aria-label="login"
                onClick={() => { history.push(`/${PATH.LOGIN}`) }}
              >
                login
              </Button>
            </Tooltip>
          }
        </div>

        {isLoggedIn && !this.props.the350club &&
          <Tooltip title="user menu">
            <Typography // changed from Button to Typography to allow custom variant
              variant="userMenu"
              aria-label="user menu"
              aria-haspopup="true">
              <Button
                variant="userMenu"
                onClick={() => { this.toggle() }}>{name}
              </Button>
            </Typography>
          </Tooltip>
        }
      </React.Fragment>
    )
  }

  render() {
    // console.log('UserMenu this.props:', this.props)
    const { features, urlTrialCode } = this.props
    const myAccount = urlTrialCode ? `/${PATH.MY_ACCOUNT}/?trial=${urlTrialCode}` : `/${PATH.MY_ACCOUNT}/`

    return (
      <Menu ref="myRef" isOpen={this.state.isMenuOpen} toggle={this.renderButton()} close={() => this.close()} align="right">
        {<li><Link to={myAccount}>My Account</Link></li>}
        {<li><Button variant="menu" onClick={() => this.props.changePassword(this.props.email)}>Change Password</Button></li>}
        {<li><Button variant="menu" onClick={() => this.logout()}>Log Out</Button></li>}
        {features.Developer && <li><Button variant="menu" onClick={() => this.switchUser()}>Switch User</Button></li>}
      </Menu>
    )
  }
}

